import { useState } from "react";
import Preloader from "@/components/Preloader";
import ScrollProgress from "@/components/ScrollProgress";
import BackToTop from "@/components/BackToTop";
import ClockWidget from "@/components/ClockWidget";
import KillFeed from "@/components/KillFeed";
import SectionNav from "@/components/SectionNav";
import MouseTrail from "@/components/MouseTrail";
import KonamiCode from "@/components/KonamiCode";
import SoundToggle from "@/components/SoundToggle";
import FloatingMenu from "@/components/FloatingMenu";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import QuoteTicker from "@/components/QuoteTicker";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Portfolio() {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <Preloader onComplete={() => setLoaded(true)} />
      {loaded && (
        <div className="relative bg-[#09090b] min-h-screen" data-testid="portfolio-page">
          <ScrollProgress />
          <MouseTrail />
          <BackToTop />
          <ClockWidget />
          <KillFeed />
          <SectionNav />
          <KonamiCode />
          <SoundToggle />
          <FloatingMenu />
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <QuoteTicker />
            <About />
            <Stats />
            <Contact />
          </main>
          <Footer />
        </div>
      )}
    </>
  );
}
